import { Icon } from "Components";
import React from "react";

const NoTenantSelectedEmptyState: React.FC = () => {
  return (
    <div className="pm-empty-card">
      <div>
        <Icon type="noCampaign" />
        <div className="pm-empty-title">No tenants selected yet</div>
      </div>

      <div className="pm-empty-description">
        You haven’t selected any tenants campaigns yet. Start by selecting a tenant
        to create a phishing campaign.
      </div>
    </div>
  );
};

export default NoTenantSelectedEmptyState;